/**
 * Nudges a filter popup down off its header cell, then pulls it back inside the viewport once the
 * browser has laid it out. Shared so both records grids position their menus identically.
 */
export const positionRecordsGridPopup = (params: { ePopup: HTMLElement }) => {
  const ePopup = params.ePopup
  const oldTopStr = ePopup.style.top
  const oldTop = parseInt(oldTopStr.substring(0, oldTopStr.indexOf('px')))

  ePopup.style.top = `${oldTop + 12}px`

  setTimeout(() => {
    const rect = ePopup.getBoundingClientRect()
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight

    if (rect.right > viewportWidth) {
      const overflow = rect.right - viewportWidth + 20
      ePopup.style.left = `${Math.max(10, rect.left - overflow)}px`
    }

    if (rect.left < 0) {
      ePopup.style.left = '10px'
    }

    if (rect.bottom > viewportHeight) {
      const overflow = rect.bottom - viewportHeight + 20
      ePopup.style.top = `${Math.max(10, rect.top - overflow)}px`
    }
  }, 50)
}
